"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var Entity_1 = require("../../Core/Entity");
var StoreEntity_1 = __importDefault(require("../../Core/StoreEntity"));
var AutoDispatchTeamState_consts_1 = require("../AutoDispatchTeamState.consts");
var VrpAutoDispatchAnalyticEntity = /** @class */ (function (_super) {
    __extends(VrpAutoDispatchAnalyticEntity, _super);
    function VrpAutoDispatchAnalyticEntity(session) {
        var _this = _super.call(this, { session: session, entityName: 'auto_dispatch_statistics', routes: [Entity_1.BaseRoutes.GetAll] }) || this;
        _this.onDoneEvent = lodash_1.noop;
        _this.realTime.on('vrp auto dispatch done', function (teamState) {
            return _this.onDoneEvent(teamState);
        });
        return _this;
    }
    VrpAutoDispatchAnalyticEntity.prototype.getTeamsStates = function () {
        return this.service.routeGenerator
            .get(AutoDispatchTeamState_consts_1.Routes.getTeamsStates)
            .withExtractor(function (response) { return response.result; })
            .invoke();
    };
    return VrpAutoDispatchAnalyticEntity;
}(StoreEntity_1.default));
exports.default = VrpAutoDispatchAnalyticEntity;
//# sourceMappingURL=VrpAutoDispatchAnalyticEntity.js.map